import React from 'react'

const IconArrowUpBig = () => {
  return (
    <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 0.633057L11.2275 5.86056L10.4615 6.6266L6.54171 2.69867V15.8076H5.45837V2.70681L1.53858 6.6266L0.772537 5.86056L6 0.633057Z" fill="#686867" />
    </svg>
  )
}

export default IconArrowUpBig
